import { render, staticRenderFns } from "./CreateGLTransaction.vue?vue&type=template&id=38a39901"
import script from "./CreateGLTransaction.vue?vue&type=script&lang=js"
export * from "./CreateGLTransaction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports